<template>
  <div class="base-layout-aside">
    <div
      :class="sideMenu == 'depth' ? 'app-title-depth app-title' : 'app-title'"
    >
      <img
        v-if="sideMenu == 'depth'"
        src="@/assets/imgs/backBtn.png"
        @click="goBack()"
        alt=""
      />
      <span>
        {{ sideTitle }}
      </span>
    </div>
    <div class="line"></div>
    <el-menu
      v-if="sideMenuList.length > 0"
      class="el-menu-aside"
      background-color="inherit"
      text-color="#FFFFFF"
      active-text-color="#FFFFFF"
      @open="handleMenuOpen"
      @close="handleMenuClose"
      :default-openeds="expandedMenu"
      :default-active="activeMenu ? activeMenu : activePath"
    >
      <IteraMenu v-for="item in sideMenuList" :key="item.id" :item="item">
      </IteraMenu>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import IteraMenu from './iteraMenu'
import { findFirstRoute } from '@/store/utils/route'
import microApp from '@micro-zoe/micro-app'

export default {
  name: 'Aside',
  components: {
    IteraMenu
  },
  watch: {
    sideMenu() {
      this.$nextTick(() => {})
    },
    appDepthMenu: {
      handler() {
        this.updateSideMenuByPath(window.location.pathname)
      },
      deep: true
    }
  },
  computed: {
    ...mapState('app', ['appMenu', 'appDepthMenu', 'expandedMenu']),
    activePath() {
      // if (this.$route.meta.type == 'MICRO_APP') {
      const sideMenuList = this.sideMenuList
      const { meta: { context = '' } = {}} = this.$route
      const url = window.location.href
      let fullPath = ''
      const startIndex = url.indexOf(`/${context}`)
      if (startIndex !== -1) {
        fullPath = url.substring(startIndex)
      }
      const contextIndex = fullPath.indexOf(`${context}/`)
      let activePath = fullPath
      if (contextIndex !== -1) {
        const startIndex = contextIndex + context.length + 1
        if (this.$route.meta.type == 'MICRO_APP') {
          activePath = fullPath.slice(startIndex)
        } else if (this.$route.meta.type == 'INNER_APP') {
          activePath = fullPath.slice(1)
        }
      }
      const queryIndex = activePath.indexOf('?')
      if (queryIndex !== -1) {
        activePath = activePath.substring(0, queryIndex)
      }
      if (!activePath || activePath == `/${context}`) {
        activePath = findFirstRoute(sideMenuList).url
      }
      activePath = this.removeTrailingHashSlash(activePath)
      return activePath
    },
    sideTitle() {
      const rawValue = localStorage.getItem('insideMenuName')
      let parsedValue = ''

      try {
        // 尝试解析 JSON，如果成功说明是带双引号的字符串
        parsedValue = JSON.parse(rawValue)
      } catch (e) {
        // 如果失败，说明不是 JSON 格式，直接使用原始值
        parsedValue = rawValue
      }

      return this.sideMenu === 'single' ? this.$route.meta.name : parsedValue
    },
    sideMenuList() {
      if (this.sideMenu == 'single') {
        return this.appMenu
      } else {
        return this.depthMenu[0].children
      }
    }
  },
  data() {
    return {
      sideMenu: 'single',
      depthMenu: [],
      activeMenu: ''
    }
  },
  mounted() {
    if (this.$route.meta.type == 'MICRO_APP') {
      this.updateSideMenuByPath(window.location.pathname)
      microApp.router.beforeEach((to, from, appName) => {
        const fullPathSegment =
          to.fullPath.split(this.$route.meta.context + '/')[1] || ''
        let activeMenu = fullPathSegment?.includes('?')
          ? fullPathSegment.slice(0, fullPathSegment.indexOf('?'))
          : fullPathSegment
        const matchedItem = this.findMenuItemByUrl(
          this.sideMenuList,
          activeMenu
        )
        if (matchedItem && matchedItem.type == 'BUTTON') {
          activeMenu = this.findMenuById(matchedItem.parentId).url
        }
        activeMenu = this.removeTrailingHashSlash(activeMenu)
        this.activeMenu = activeMenu
        this.updateSideMenuByPath(to.pathname)
      })
      microApp.router.afterEach(() => {
        this.$nextTick(() => {
          this.setTabData()
        })
      })
    } else if (this.$route.meta.type == 'INNER_APP') {
      const fullPathSegment = this.$route.fullPath.slice(1)
      let activeMenu = fullPathSegment?.includes('?')
        ? fullPathSegment.slice(0, fullPathSegment.indexOf('?'))
        : fullPathSegment
      const matchedItem = this.findMenuItemByUrl(this.sideMenuList, activeMenu)
      if (matchedItem && matchedItem.type == 'BUTTON') {
        activeMenu = this.findMenuById(matchedItem.parentId).url
      }
      activeMenu = this.removeTrailingHashSlash(activeMenu)
      this.activeMenu = activeMenu

      // 维护父级菜单展开状态
      this.updateExpandedMenuByRoute(activeMenu)

      // 监听路由变化，维护菜单展开状态
      this.$router.afterEach((to) => {
        const fullPathSegment = to.fullPath.slice(1)
        let menuPath = fullPathSegment?.includes('?')
          ? fullPathSegment.slice(0, fullPathSegment.indexOf('?'))
          : fullPathSegment
        menuPath = this.removeTrailingHashSlash(menuPath)
        this.updateExpandedMenuByRoute(menuPath)
      })
    }
  },
  methods: {
    /**
     * 根据当前路由更新展开的父级菜单
     * @param {String} currentPath 当前路由路径
     */
    updateExpandedMenuByRoute(currentPath) {
      if (!currentPath) return
      const matchedItem = this.findMenuItemByUrl(this.sideMenuList, currentPath)
      if (matchedItem) {
        const allAncestors = this.findAllAncestors(matchedItem.id)
        const expandedMenu = [...this.expandedMenu]
        allAncestors.forEach((ancestorId) => {
          if (!expandedMenu.includes(ancestorId)) {
            expandedMenu.push(ancestorId)
          }
        })
        this.$store.dispatch('app/updateExpandedMenu', expandedMenu)
      }
    },
    /**
     * 递归查找所有祖先菜单的 id
     * @param {String} menuId 菜单项 id
     * @returns {Array} 所有祖先菜单 id 数组
     */
    findAllAncestors(menuId) {
      const ancestors = []
      let current = this.findMenuById(menuId)
      while (current && current.parentId && current.parentId !== current.appId) {
        const parent = this.findMenuById(current.parentId)
        if (parent && parent.type === 'MENU') {
          ancestors.push(parent.id)
        }
        current = parent
      }
      return ancestors
    },
    handleMenuOpen(index) {
      const expandedMenu = [...this.expandedMenu]
      const allAncestors = this.findAllAncestors(index)
      let updated = false
      if (!expandedMenu.includes(index)) {
        expandedMenu.push(index)
        updated = true
      }
      allAncestors.forEach((ancestorId) => {
        if (!expandedMenu.includes(ancestorId)) {
          expandedMenu.push(ancestorId)
          updated = true
        }
      })
      if (updated) {
        this.$store.dispatch('app/updateExpandedMenu', expandedMenu)
      }
    },
    handleMenuClose(index) {
      const expandedMenu = this.expandedMenu.filter((item) => item !== index)
      this.$store.dispatch('app/updateExpandedMenu', expandedMenu)
    },
    /**
     * 如果字符串末尾是 '#/' 并且不是 '/#/'，则去掉末尾的 '#/'
     * @param {string} str - 要处理的字符串
     * @returns {string} 处理后的字符串
     */
    removeTrailingHashSlash(str) {
      // 检查字符串是否以 '#/' 结尾，且不以 '/#/' 结尾
      if (str.endsWith('#/') && !str.endsWith('/#/')) {
        return str.slice(0, -2) // 去掉最后两个字符
      }
      return str
    },
    setTabData() {
      const tabTitle = this.$store.state.config.clientEndTitle
      document.title = tabTitle // 设置浏览器tab标题
    },
    updateSideMenuByPath(pathname) {
      if (this.appDepthMenu.length > 0) {
        let found = false
        for (const item of this.appDepthMenu) {
          if (pathname.includes(item.url)) {
            this.depthMenu = [item]
            found = true
            break
          }
        }
        this.sideMenu = found ? 'depth' : 'single'
      } else {
        this.sideMenu = 'single'
      }
    },
    goBack() {
      let item = {}
      if (this.depthMenu[0].parentId == this.depthMenu[0].appId) {
        item = findFirstRoute(this.appMenu)
      } else {
        item = this.findMenuById(this.depthMenu[0].parentId)
      }
      window.location.href = `/${this.$route.meta.context}/` + item.url
      // microApp.router.push({
      //   name: this.$route.meta.context,
      //   path: `/${this.$route.meta.context}/` + item.url,
      //   replace: true,
      // });
    },
    /**
     * 递归查找菜单项
     * @param {Array} menuList 菜单数组
     * @param {String} targetUrl 匹配的 url
     * @returns {Object|undefined} 找到的对象或 undefined
     */
    findMenuItemByUrl(menuList, targetUrl) {
      for (const item of menuList) {
        if (item.url === targetUrl) {
          return item
        }
        if (item.children && Array.isArray(item.children)) {
          const result = this.findMenuItemByUrl(item.children, targetUrl)
          if (result) {
            return result
          }
        }
      }
      return undefined
    },
    findMenuById(id) {
      if (!this.appMenu || !Array.isArray(this.appMenu)) {
        return undefined
      }
      const findInMenu = (menu) => {
        for (const item of menu) {
          if (item.id === id) {
            return item
          }
          if (item.children && Array.isArray(item.children)) {
            const found = findInMenu(item.children)
            if (found) {
              return found
            }
          }
        }
        return undefined
      }

      return findInMenu(this.appMenu)
    }
  }
}
</script>
